// Presentation mapping for the live consultations listing (@astro/api → card props).
// The old hardcoded CONSULTATIONS array is gone — the section now fetches from
// GET /v1/astrologers/filter (server-side search, filters, sort, pagination)
// and decorates each astrologer record here.

/** Sort choices mapped to the /astrologers/filter sort_by + sort_order params. */
export const SORT_OPTIONS = [
  { value: 'rating', label: 'Top Rated' },
  { value: 'experience', label: 'Most Experienced' },
  { value: 'price-low', label: 'Price Low to High' },
  { value: 'price-high', label: 'Price High to Low' },
]

export const SORT_PARAMS = {
  rating: { by: 'rating', order: 'desc' },
  experience: { by: 'experience', order: 'desc' },
  'price-low': { by: 'rate', order: 'asc' },
  'price-high': { by: 'rate', order: 'desc' },
}

/** Minimum years of experience → min_experience param. */
export const EXPERIENCE_OPTIONS = [
  { value: 'any', label: 'Any experience' },
  { value: '5', label: '5+ years' },
  { value: '10', label: '10+ years' },
  { value: '15', label: '15+ years' },
]

/** Slider ceiling — at this value the max_rate param is omitted (no cap). */
export const MAX_PRICE = 5000

export const DEFAULT_FILTERS = {
  search: '',
  /** Skill display name — the live filter endpoint matches names, not slugs. */
  expertise: 'any',
  /** Language display name. */
  language: 'any',
  /** Minimum experience in years. */
  experience: 'any',
  sort: 'rating',
  maxPrice: MAX_PRICE,
}

/** Photo-fallback gradients, cycled by list position. */
const FALLBACK_GRADIENTS = [
  'linear-gradient(160deg,#FDE68A 0%,#F59E0B 50%,#D97706 100%)',
  'linear-gradient(160deg,#FDE8D8 0%,#F4A261 50%,#E76F51 100%)',
  'linear-gradient(160deg,#FEF3C7 0%,#FBBF24 50%,#D97706 100%)',
  'linear-gradient(160deg,#EDE9FE 0%,#A78BFA 50%,#7C3AED 100%)',
]

/** Shape a live astrologer record into the props ConsultationCard renders. */
export function decorateConsultation(record, index) {
  const name = record.display_name || record.name
  // Treat missing online_status as available (the plain listing omits it).
  const online = record.online_status ? record.online_status === 'online' : true
  const skills = record.skills ?? []
  const rating = Number(record.rating ?? 0)

  return {
    id: record.id,
    title: name,
    desc: skills.length
      ? `Personalised guidance in ${skills.join(', ')}.`
      : 'Personalised Vedic astrology consultation.',
    categoryLabel: skills[0] ?? 'Vedic Astrology',
    typeLabel: online ? 'Online' : 'Offline',
    languages: record.languages ?? [],
    exp: record.experience ?? 0,
    duration: record.duration,
    price: Number(record.rate) || 0,
    rating,
    reviews: record.reviews_count ?? 0,
    featured: rating >= 4.5,
    image: record.image_url,
    fallbackGradient: FALLBACK_GRADIENTS[index % FALLBACK_GRADIENTS.length],
    fallbackLetter: (name || 'A').charAt(0).toUpperCase(),
  }
}
